/**
 * LUXIRE ADD-ON PRICING v2
 * Global search across all hidden products to find matching priced variants.
 * Map includes prices so we can verify matches.
 */
(function(){
'use strict';

var addonMap = null;
var pricedIndex = null; // flat: [{norm, name, id, price, handle}]

function norm(s) { return (s||'').toLowerCase().replace(/[^a-z0-9]/g,''); }

function loadMap() {
  if (addonMap) return Promise.resolve(addonMap);
  var url = window.LuxireAddonMapUrl;
  if (!url) return Promise.resolve({});
  return fetch(url)
    .then(function(r) { return r.json(); })
    .then(function(data) {
      addonMap = data;
      buildPricedIndex();
      return data;
    })
    .catch(function(e) { console.warn('[Luxire] Addon map load failed:', e); addonMap = {}; return {}; });
}

function buildPricedIndex() {
  pricedIndex = [];
  for (var handle in addonMap) {
    if (handle === 'additional-service') continue;
    var variants = addonMap[handle];
    for (var opt in variants) {
      var info = variants[opt];
      if (info.price > 0) {
        pricedIndex.push({
          norm: norm(opt),
          name: opt,
          id: info.id,
          price: info.price,
          handle: handle
        });
      }
    }
  }
}

// Find best matching priced variant globally — categoryHint biases toward variants
// from products whose handle contains the category name (e.g. "waistband" → prefer
// hidden_internal_product_waistband_style over hidden_internal_product_pants_style
// for "Gurkha"). Without the hint, behavior is the original cross-category search.
function findPricedVariant(optionName, expectedPrice, categoryHint) {
  if (!pricedIndex) return null;
  var target = norm(optionName);
  var ep = parseFloat(expectedPrice) || 0;
  // Split categoryHint into >2-char keywords for handle matching
  var catWords = [];
  if (categoryHint) {
    catWords = (categoryHint + '').toLowerCase().split(/\s+/)
      .map(function(w){ return w.replace(/[^a-z0-9]/g,''); })
      .filter(function(w){ return w.length > 2; });
  }
  function inCategory(v) {
    if (!catWords.length) return false;
    var h = (v.handle || '').toLowerCase();
    for (var i = 0; i < catWords.length; i++) {
      if (h.indexOf(catWords[i]) !== -1) return true;
    }
    return false;
  }

  // 1. Exact normalized match + correct price + category match (best possible)
  for (var i = 0; i < pricedIndex.length; i++) {
    var v = pricedIndex[i];
    if (v.norm === target && Math.abs(v.price - ep) < 0.01 && inCategory(v)) return v;
  }
  // 2. Exact normalized match + correct price (any category)
  for (var i = 0; i < pricedIndex.length; i++) {
    var v = pricedIndex[i];
    if (v.norm === target && Math.abs(v.price - ep) < 0.01) return v;
  }
  // 3. Exact normalized match, any price, in category
  for (var i = 0; i < pricedIndex.length; i++) {
    var v = pricedIndex[i];
    if (v.norm === target && inCategory(v)) return v;
  }
  // 4. Exact normalized match, any price (any category)
  for (var i = 0; i < pricedIndex.length; i++) {
    var v = pricedIndex[i];
    if (v.norm === target) return v;
  }
  // 5. Partial match in category with correct price
  for (var i = 0; i < pricedIndex.length; i++) {
    var v = pricedIndex[i];
    if (Math.abs(v.price - ep) < 0.01 && inCategory(v)) {
      if (v.norm.indexOf(target) !== -1 || target.indexOf(v.norm) !== -1) return v;
    }
  }
  // 6. Partial match with correct price (any category — old behavior)
  for (var i = 0; i < pricedIndex.length; i++) {
    var v = pricedIndex[i];
    if (Math.abs(v.price - ep) < 0.01) {
      if (v.norm.indexOf(target) !== -1 || target.indexOf(v.norm) !== -1) return v;
    }
  }

  // 7. Keyword overlap with correct price (category match boosts score)
  if (ep > 0) {
    var targetWords = target.match(/[a-z]{3,}/g) || [];
    var bestMatch = null, bestScore = 0;
    for (var i = 0; i < pricedIndex.length; i++) {
      var v = pricedIndex[i];
      if (Math.abs(v.price - ep) !== 0) continue;
      var score = 0;
      for (var w = 0; w < targetWords.length; w++) {
        if (v.norm.indexOf(targetWords[w]) !== -1) score++;
      }
      if (inCategory(v)) score += 2; // strong category preference
      if (score > bestScore) { bestScore = score; bestMatch = v; }
    }
    if (bestMatch && bestScore >= 1) return bestMatch;
  }

  return null;
}

// Fallback: additional-service variant
function findServiceVariant(amount) {
  if (!addonMap || !addonMap['additional-service']) return null;
  var svc = addonMap['additional-service'];
  var key = String(amount);
  if (svc[key]) return svc[key].id || svc[key];
  // Try matching
  for (var k in svc) {
    var info = svc[k];
    var price = info.price || parseFloat(k);
    if (Math.abs(price - amount) < 0.01) return info.id || info;
  }
  return null;
}

/**
 * Build add-on line items from style selections
 * @param {Object} defaults - optional. If provided, skip charging when curVals[key] === defaults[key]
 */
function buildAddonItems(productType, styleOptions, curVals, styleKeys, measMethod, defaults) {
  var items = [];
  var usedVariants = {};
  var debugLog = [];

  // Charge a single selected value: find its price, resolve a variant, push a line item.
  function processValue(key, val) {
    if (!val || val === 'None') return;

    // For monogram, val may be "Back Pocket — JKR · Navy · Script" - strip details for matching
    var matchVal = val;
    if (key === 'monogram' && val.indexOf(' — ') > -1) {
      matchVal = val.split(' — ')[0];
    }

    // Get charge from style data
    var opts = styleOptions[key].options || [];
    var charge = 0;
    for (var i = 0; i < opts.length; i++) {
      var opt = opts[i];
      var name = opt.name || opt;
      if ((name === matchVal || name === val) && opt.price) {
        var p = String(opt.price).replace(/[^0-9.]/g, '');
        if (p) charge = parseFloat(p);
        break;
      }
    }
    if (charge <= 0) {
      debugLog.push({ key: key, val: val, skipped: 'no price' });
      return;
    }

    // Find matching priced variant
    var match = null;
    if (key === 'monogram') {
      var monoHandle = (productType === 'jacket' || productType === 'suit') ? 'hidden-internal-product-jacket-monogram' : 'hidden-internal-product-monogram';
      if (addonMap && addonMap[monoHandle]) {
        var monoVariants = addonMap[monoHandle];
        for (var mk in monoVariants) { match = { id: monoVariants[mk].id || monoVariants[mk], price: monoVariants[mk].price || charge, name: 'Monogram' }; break; }
      }
    } else {
      match = findPricedVariant(val, charge, styleOptions[key].title || key);
    }

    // Display price: prefer the matched variant's real price so the shown "+$N" equals the charge
    var displayPrice = (match && match.price > 0) ? match.price : charge;

    var catTitle = (styleOptions[key].title || key);
    var addonLabel, visibleLabel;
    if (key === 'monogram') {
      addonLabel = 'Monogram — ' + val.split(' — ')[0] + ' (+$' + displayPrice + ')';
      visibleLabel = 'Monogram — ' + val.split(' — ')[0];
    } else {
      addonLabel = val + ' (+$' + displayPrice + ')';
      visibleLabel = catTitle + ' — ' + val;
    }

    if (match && !usedVariants[match.id]) {
      usedVariants[match.id] = true;
      items.push({ id: match.id, quantity: 1, properties: { 'Add-on': visibleLabel, '_for': addonLabel, '_linked': productType } });
      debugLog.push({ key: key, val: val, charged: displayPrice, via: 'variant ' + match.id });
    } else if (!match) {
      var svcId = findServiceVariant(charge);
      if (svcId) {
        items.push({ id: svcId, quantity: 1, properties: { 'Add-on': visibleLabel, '_for': addonLabel, '_linked': productType } });
        debugLog.push({ key: key, val: val, charged: charge, via: 'additional-service' });
      } else {
        debugLog.push({ key: key, val: val, FAILED: 'no variant for $' + charge });
      }
    } else {
      debugLog.push({ key: key, val: val, skipped: 'duplicate variant' });
    }
  }

  (styleKeys || Object.keys(curVals)).forEach(function(key) {
    var rawVal = curVals[key];
    if (!rawVal || !styleOptions[key]) return;

    // Skip if the whole selection matches the as-shown default (already in base price)
    if (defaults && defaults[key] === rawVal) {
      debugLog.push({ key: key, val: rawVal, skipped: 'matches default' });
      return;
    }

    // Multi-select categories store several picks joined as "A, B, C" — charge each.
    // Only split when the whole value is NOT itself an option name (so names are safe).
    var optNames = (styleOptions[key].options || []).map(function(o){ return o.name || o; });
    var values;
    if (key === 'monogram' || optNames.indexOf(rawVal) > -1 || rawVal.indexOf(', ') === -1) {
      values = [rawVal];
    } else {
      values = rawVal.split(', ').map(function(s){ return s.trim(); });
    }
    values.forEach(function(v){ processValue(key, v); });
  });

  // Measurement method add-on
  if (measMethod === 'send' || measMethod === 'sendgarment' || measMethod === 'sendGarment') {
    var measName = (productType === 'shirt') ? 'Shipping Fee For Sending Sample' : 'Shipping Fee for Sending Sample Pants';
    var measMatch = findPricedVariant(measName, 25);
    if (measMatch && !usedVariants[measMatch.id]) {
      items.push({ id: measMatch.id, quantity: 1, properties: { 'Add-on': 'Send a garment for reference', '_for': 'Send a Garment (+$25)', '_linked': productType } });
    }
  }

  if (window.console && window.console.table) {
    console.groupCollapsed('[Luxire] buildAddonItems → ' + items.length + ' addon line items for ' + productType);
    console.table(debugLog);
    console.log('items:', items);
    console.groupEnd();
  }

  return items;
}

function addWithAddons(mainVariantId, mainProps, addonItems) {
  // Generate unique session ID to link main product with its addons
  var sessionId = String(Date.now()) + '_' + Math.random().toString(36).substr(2, 5);
  if (addonItems && addonItems.length > 0) {
    mainProps['_session'] = sessionId;
  }
  // Tag add-on items with the session ID so cart drawer can group them under the main product
  (addonItems || []).forEach(function(a) {
    if (!a.properties) a.properties = {};
    a.properties['_parent'] = sessionId;
  });
  // Order: add-ons FIRST in the array, main LAST — Shopify lists newest line items at the top
  // of the checkout, so the main product ends up on top (and add-ons under it).
  var items = (addonItems || []).slice();
  items.push({ id: mainVariantId, quantity: 1, properties: mainProps });

  return fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ items: items })
  })
  .then(function(r) { return r.json(); })
  .then(function() {
    if (typeof LuxireCart !== 'undefined') LuxireCart.open();
    else window.location = '/cart';
  })
  .catch(function(e) {
    console.error('[Luxire] Add to cart error:', e);
    alert('Error adding to cart. Please try again.');
  });
}

loadMap();

window.LuxireAddon = {
  loadMap: loadMap,
  buildAddonItems: buildAddonItems,
  addWithAddons: addWithAddons,
  findPricedVariant: findPricedVariant
};
})();
